import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Header from '../layout/Header';
import BriefConversation from "../pages/BriefConversation";
import { Helmet } from 'react-helmet';

export class IntegrationServices extends Component {
   render() {
      const formtext = (
         <>
         <div className="formContentBox">
           <p>Drop us a message and we will connect with you to discuss your requirements and propose how we can be of help.</p>
           </div>
         </>
       );
     
      return (
         <>
         <Helmet>
            <title>Salesforce Integration Services - Thinqloud</title>
         </Helmet>
         <div className="site-main">
            <Header />
            <div className="ttm-page-title-row ttm-page-title-row9 ttmpagetitlerow5">
               <div className="container-xl">
                  <div className="row">
                     <div className="col-md-12">
                        <div className="title-box text-center">
                           <div className="page-title-heading">
                              <h2 className="title sh2">Salesforce® Integration Services</h2>
                              <h1 className="title sh2 displyNone">Salesforce® Integration Services</h1>
                              <p className="banner-subtitle">Achieve the most out of Salesforce®</p>
                           </div>
                           <div className="breadcrumb-wrapper">
                              <span>
                                 <a title="Homepage" href={process.env.PUBLIC_URL + "/"}>
                                    <i className="ti ti-home" />
                                    &nbsp;&nbsp;Home
                                 </a>
                              </span>
                              <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                              <span>Salesforce® Integration Services</span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
               <div className="container-xl">
                  <div className="row">
                     <div className="col-lg-9 content-area order-lg-2">
                        <div className="section-title with-desc clearfix">
                                <div className="title-header">
                                    <h2 className="title"> Salesforce® Integration <span>Services</span></h2>
                                </div>
                                </div>
                        <div className="ttm-service-single-content-area">
                           <div className="ttm-service-description">
                              <p>At Thinqloud, we pride ourselves on being a premier Salesforce consulting organization, seamlessly connecting Salesforce with the world. Our expertise spans across a spectrum of integration scenarios, ensuring that your Salesforce environment communicates flawlessly with other systems, both cloud and on-premise. Dive into our extensive integration capabilities:</p>
                              <div className="row">
                                 <div className="col-md-6">
                                    <div className="ttm_single_image-wrapper">
                                       <img className="img-fluid" src="/images/single-img-eighteen.png" alt="single-img-eighteen" />
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <p ><strong className='h4TagTitle'>1. Salesforce with Other Cloud Systems</strong></p>
                                    <ul className="ttm-list ttm-list-style-icon">
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Seamless data flow between Salesforce and your favourite cloud platforms.</span></li>
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Real-time or batch synchronization ensuring your data is always up-to-date.</span></li>
                                    </ul>
                                 </div>
                              </div>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="row mb-35">
                                 <div className="col-md-6">
                                    <p><strong className='h4TagTitle'>2. Salesforce to On-Premise Systems Integration</strong></p>
                                    <ul className="ttm-list ttm-list-style-icon">
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Bridge your in-house applications with Salesforce, ensuring consistency and coherence.</span></li>
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Our solutions prioritize security, ensuring your data is transmitted safely.</span></li>
                                    </ul>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="ttm_single_image-wrapper res-767-mt-20">
                                       <img className="img-fluid" src="/images/single-img-nineteen.png" alt="single-img-nineteen" />
                                    </div>
                                 </div>
                              </div>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="row">
                                 <div className="col-md-6">
                                    <div className="ttm_single_image-wrapper">
                                       <img className="img-fluid" src="/images/major-cloud-providers.png" alt="" />
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                 <p><strong className='h4TagTitle'>3. Salesforce and Major Cloud Providers</strong></p>
                                    <ul className="ttm-list ttm-list-style-icon">
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Salesforce to AWS:</strong> Leverage the power of Amazon Web Services, connecting S3, Lambda, EC2, and more with Salesforce.</span></li>
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Salesforce to GCP:</strong> Integrate seamlessly with Google Cloud Platform services ensuring dynamic data flow.</span></li>
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Salesforce to Azure:</strong> Bring together the capabilities of Microsoft Azure and Salesforce for a holistic cloud experience.</span></li>
                                    </ul>
                                 </div>
                              </div>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="row mb-35">
                                 <div className="col-md-6">
                                 <p><strong className='h4TagTitle'>4. Bulk Data Handling</strong></p>
                                    <ul className="ttm-list ttm-list-style-icon">
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Bulk Data Import:</strong> Introduce large sets of data into Salesforce from CSV/JSON without a hassle.</span></li>
                                       <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Bulk Data Export:</strong> Extract vast amounts of data from Salesforce in structured formats like CSV/JSON for any downstream processing or backup.</span></li>
                                    </ul>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="ttm_single_image-wrapper res-767-mt-20">
                                       <img className="img-fluid" src="/images/bulk-data.png" alt="" />
                                    </div>
                                 </div>
                              </div>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <p><strong className='h4TagTitle'>Integration Tools We Excel In:</strong></p>
                              <ul className="ttm-list ttm-list-style-icon">
                                 <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Mulesoft:</strong> Mastering complex integrations using one of the industry’s leading platforms.</span></li>
                                 <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Jitterbit:</strong> Accelerating connections with this powerful, yet agile, cloud platform connector.</span></li>
                                 <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Bhoomi:</strong> Crafting integrations that are both sturdy and efficient, catering to your unique business needs.</span></li>
                                 <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>Talend:</strong> Ensuring high-quality, trustworthy data integrations across platforms.</span></li>
                                 <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content"><strong className='strongFont'>io:</strong> Simplifying your data import and export processes, making them quicker and more streamlined.</span></li>
                              </ul>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="row mb-35">
                                 <div className="col-md-6">
                                    <div className="section-title with-desc clearfix">
                                        <div className="title-header">
                                            <p className="h2Ptag">Why <span className='h2tagItalic'>Choose Us?</span></p>
                                        </div>
                                        </div>
                                    <p>Our seasoned team of Salesforce consultants and integration experts ensure not only that different platforms talk to each other but that they do so efficiently, securely, and in a manner that drives value to your business. From strategy to execution, we’ve got you covered.</p>
                                    <p>Reach out today, and let’s craft a robust integration solution tailor-made for your business.</p>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="ttm_single_image-wrapper res-767-mt-20">
                                       <img className="img-fluid" src="/images/why-choose-us.png" alt="why-choose-us" />
                                    </div>
                                 </div>
                              </div>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="row">
                                 <div className="col-12">
                                     <div className="featured-desc">
                                       <p>By using Force.com® standard functionality and AppExchange solutions to the greatest extent we provide faster time-to-value and greater cost savings for you. We can help you achieve the most out of Salesforce® Integrated Solution, ensuring more successful and extended use of the Salesforce® platform.

</p>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon21.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Salesforce® integration Design</h3>
                                          </div>

                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon22.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Integration Deployment</h3>
                                          </div>

                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon23.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Salesforce® Custom coding</h3>
                                          </div>

                                       </div>
                                    </div>
                                 </div>
                                 
                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon24.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Force.com® Integration Development</h3>
                                          </div>

                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon25.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Testing of integration components</h3>
                                          </div>

                                       </div>
                                    </div>
                                 </div>


                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon15.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Salesforce® System Integration</h3>
                                          </div>
                                         
                                       </div>
                                    </div>
                                 </div>

                                 <div className="col-md-6">
                                    <div className="featured-icon-box style3 left-icon icon-align-top">
                                       <div className="featured-icon">
                                          <div className="ttm-icon ttm-textcolor-skincolor ttm-icon_element-size-lg">
                                             <img src="/images/imgIcon18.png" className="imgIcon3"/>
                                          </div>
                                       </div>
                                       <div className="featured-content">
                                          <div className="featured-title">
                                             <h3 class="h4TagTitle">Data and Application Orchestration using Mulesoft</h3>
                                          </div>
                                          <div className="featured-desc">
                                             <p>Device integration, Data Transfer, Data Orchestration, Data Integration</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                             

                           </div>
                        </div>
                     </div>
                     <div className="col-lg-3 widget-area">
                        <Sidebar />
                     </div>
                  </div>
               </div>
               <BriefConversation formtext={formtext} />
            </div>
         </div>
         </>
      )
   }
}
export default IntegrationServices;